import { ID_SYSTEM_INFORMATION } from '../Settings/Constants/Constants';
import { HttpClient } from '../Utils/ApiUtilies/Fetch/Fetch';

export const FRONTENDCRM_URL = 'https://crm.business-litethinking.com/';
export const LOCATION_URL = 'https://ipapi.co/json/'; //get
export const PREVIEW_URL = 'https://getlinkpreview.onrender.com/'; //post
export const API_CODE_VERIFICATION = '/api-code-verification/'; //post
export const REGISTER_PATH = '/api-virtual-campus-users/'; //post patch
export const LOGIN_SOCIAL_PATH = '/api-social-auth/'; //post
export const COURSES_LIST_PATH = '/api-virtual-campus-courses/'; //get
export const COURSES_LIST_PATH_PORTFOLIO = '/api-virtual-campus-courses-portfolio/'; //get
export const LANGUAGE_LIST_PATH = '/api-multilanguage-list/'; //get
export const GET_API_BANNER_VIDEOS = '/api-virtual-campus-introductory-banner/'; //get
export const GENERAL_BANNER_LIST_PATH = '/api-virtual-campus-general-banner/'; //get
export const CONSULTANTS_LIST_PATH = '/api-virtual-campus-consultants/'; //get
export const REGISTER_BUY_PATH = '/api-users-courses-modes';
export const GET_COUNTRIES_MULTILANGUAJE = '/api-countries-multilanguaje/'; //get
export const GET_CITIES = '/api-cities/'; //get
export const COMPANIES_LIST_PATH = '/api-virtual-campus-companies-portal/'; // get
export const REGISTER_USER_PATH = '/api-virtual-campus-user-register/'; //POST
export const DOCUMENTS_PATH = '/api-documents/'; //GET
export const GET_PARTNERS_LIST_PATH = '/api-virtual-campus-partners/'; //GET
export const GET_STRATEGIC_LINES_LIST_PATH = '/api-virtual-campus-strategic-lines/'; //GET
export const GET_PORTFOLIOS_LIST_PATH = '/api-virtual-campus-portfolios/'; //get
export const GET_PORTFOLIOS_LIST_PATH_SERVICE = '/api-virtual-campus-portfolios-university/'; //get
export const GET_NEWS_LIST_PATH = '/api-virtual-campus-news/'; //get
export const GET_CONSULTANTS_BY_COURSE = '/api-consultant-by-course/'; //get
export const STRIPE_API = '/api-strip-integration/'; //get
export const NEXT_EVENTS_PATH = '/api-next-events/'; //get
export const GET_JOBS = '/api-jobs-portal/';
export const CERTIFICATIONS = '/api-certifications-by-course'; //get
export const GET_INFORMATION_SYSTEM = '/api-information-system/'; //get
export const GET_CHALLENGE = '/api-challenge-only/'; //get
export const API_SCALES = '/api-challenge-scales/'; //get
export const API_CHALLENGE_PRESENTATION = '/api-challenge-presentation/';
export const API_SOCIAL_MEDIA = '/api-social-media/';
export const API_JOB_QUESTION = '/api-job-filter-list/';
export const API_POSTULATION = '/api-postulation/';
export const API_VIRTUAL_CAMPUS_SPONSOR_MEDIA = '/api-virtual-campus-sponsor-media/';
export const API_ENGLISH_REGISTER = '/api-english-register/';
export const API_REGISTRATION_CHALLENGE_PRESENTATION = '/api-registration-challenge-presentation/';
export const API_GET_RESUME = '/api-resume/';
export const API_REGISTRATION_CHALLENGE_RESULT = '/api-registration-challenge-result/';
export const API_LEADER_TESTIMONIAL = '/api-leader-testimonial/';
export const API_SYNCRONOUSCLASS_VIEW = '/api-synchronousclass-api-view/';
export const API_ABOUT_COURSE = '/api-about-course/';
export const API_INFO_FILIAL = '/api-info-filial';
export const API_SCHEDULER_INFO = '/api-language-scheduler-info/';
export const API_USER_DOCUMENT_TYPE = '/api-user-document-type/';
export const API_USER_ENROLLMENT = '/api-user-enrollment-ecosystem/';
export const API_DOCUMENT_TYPE_COUNTRIES = '/api-document-type-countries/';
export const API_GET_NAME_SCHEDULER = '/api-scheduler-name/';
export const API_PERSONAL_DATA = '/api-personal-data/';
export const API_CREATE_USER = '/create-user-validated/';
export const API_REGISTER = '/api-agenda-generals/';
export const API_MEMBERSHIPS_DETAILS = '/api-membership-price-detail-portal/';
export const API_PARAMETER_MULTILINGUAGE = '/api-parameters-multilanguage/';
export const API_BANNER_INTRODUCTORY_ACTICLE = '/api-virtual-campus-introductory-article/';
export const API_PREVIEW_CLIP = '/api-course-clip-preview/';
export const API_SHOW_REGISTER_FORM = '/api-show-register-form/';
export const API_TOKEN = '75853e402747730aaffc3c3b2fbb687cc46111da';
export const GET_CONSULTANTS_EXTERNAL = '/api-consultant-external-by-course/';
export const GET_CONSULTANTS_INTERNAL = '/api-consultant-internal-by-course/';
export const API_MULTILANGUAGE_PARAMETERS = '/api-multilanguage-parameters/'; // get multilanguage text
export const API_STANDARD_PARAMETERS = '/api-standard-parameters/'; // get standard
export const API_DETAIL_PARAMETERS = '/api-detail-parameters/'; // get details (img, videos)
export const API_WEBLINK_PARAMETERS = '/api-weblink-parameters/'; // get links
export const API_MAIN_PARAMETER_MULTILANGUAGE = '/api-main-multilanguage-parameter/'; // get multialnguage with main parameter
export const API_MAIN_DETAIL_PARAMETER = '/api-main-detail-parameter/'; // get detail with main parameter
export const API_MAIN_WEBLINK_PARAMETER = '/api-main-weblink-parameter/'; // get links with main parameter
export const API_NAME_MEMBERSHIP_GROUPS = '/api-group-name/';
export const API_STRATEGIC_LINE = '/api-strategic-line/';
export const API_CONTENT_MULTILANGUAGE = '/api-content-multilanguage/';
export const API_MEMBERSHIP_PRICE_DEFAULT = '/api-membership-price-default/';
export const API_GROUP_MODE = '/api-group-mode/';
export const API_SCHEDULER_MEMBERSHIP = '/api-scheduler-membership/';
export const API_PORTFOLIO_SOFTWARE_FACTORY = '/api-virtual-campus-portfolios-software-factory/';
export const API_PORTFOLIO_CONSULTING = '/api-virtual-campus-portfolios-consulting/';
export const API_PARAMETER_NAVBAR = '/api-parameter-navbar/';
export const API_REFERENCE_TYPE = '/api-reference-types/';
export const API_VARIALBE_FIELD = '/api-variables-ecosystem/';
export const API_TYPES_WIDGETS = '/api-widget-types/';
export const API_COUNTRY_CODE = '/api-country-code/';
export const API_REGISTER_USERS = '/user-workflow-rules/';
export const API_VALIDATE_CREATE_USER = '/api-ecosystem-users/';
export const API_ENRROLMENT_VALIDATION_FORM = '/api-user-enrollment-form-validation/';
export const API_ENROLLMENT_VALIDATION_REGISTER = '/api-user-enrollment-validation-ecosystem/';
export const GET_INFORMATION_SYSTEM_ALL = '/api-information-system-all/';
export const API_PHONE_TYPE = '/api-phone-type/';
export const API_POSTULATION_ECOSYSTEM = '/api-postulation-ecosystem/';
export const API_VALIDATION_POSTULATION = '/api-postulation-validation/';
export const API_MEMBERSHIPS_DETAILS_ECOSYSTEM = '/api-membership-price-detail-ecosystem/';

//IMPORTANT: Comment or uncomment BACKEND_URL for to deploy
export const BACKEND_URL = 'https://backend.litethinking.com';
// export const BACKEND_URL = 'https://pre-backend.litethinking.com';
let FRONTEND_URL; //comment for local
let FRONTENDLMS_URL;
let FRONTMICROSITE;
let CREDENTIALS_URL;
let JOBS_URL;

//this function load the url for environment
export const loadEnvironmentUrls = async () => {
  if (FRONTENDLMS_URL) return;
  try {
    const data = await HttpClient.GET(GET_INFORMATION_SYSTEM_ALL);
    const resLms = data.content.find((system) => system.id === ID_SYSTEM_INFORMATION.LMS);
    const resCredentials = data.content.find(
      (system) => system.id === ID_SYSTEM_INFORMATION.CREDENTIAL
    );
    const resJobs = data.content.find((system) => system.id === ID_SYSTEM_INFORMATION.JOBS);
    const resPortal = data.content.find((system) => system.id === ID_SYSTEM_INFORMATION.PORTAL);
    const resOnlinePay = data.content.find(
      (system) => system.id === ID_SYSTEM_INFORMATION.ONLINE_PAY
    );

    FRONTENDLMS_URL = resLms.url || FRONTENDLMS_URL;
    CREDENTIALS_URL = resCredentials.url || CREDENTIALS_URL;
    JOBS_URL = resJobs.url || JOBS_URL;
    FRONTEND_URL = resPortal.url || FRONTEND_URL; //comment for local
    FRONTMICROSITE = resOnlinePay.url || FRONTMICROSITE;
  } catch (error) {
    console.error('Error loading environment URLs:', error);
  }
};

export { FRONTEND_URL, FRONTENDLMS_URL, CREDENTIALS_URL, JOBS_URL, FRONTMICROSITE };

// export { FRONTENDLMS_URL, CREDENTIALS_URL, JOBS_URL, FRONTMICROSITE }; //Uncomment for local
// export const FRONTEND_URL = 'http://localhost:3000';
